import usePendenciesFilter from '@/data/hook/usePendenciesFilter';
import useListService from '@/data/hook/useListService';
import { scheduledLessonsQueryKeys } from '@/data/services/querykeys';
import { REQUEST_STALE_TIME_IN_MS as staleTime } from '@/constants';
import AttendancePendenciesTable from '@/components/shared/pendencies/tables/AttendancePendenciesTable';

import User from '@/models/User';
import { SmartTableClassNames } from '@/components/ui/daisy/templates/smart-table/types';

type PendenciesDashboardTabProps = {
  user: User;
  tableClassNames: SmartTableClassNames;
  tableClassName: string;
  emptyMessage?: string;
  pageSize?: number;
};

export function PendenciesDashboardTab({
  user,
  tableClassNames,
  tableClassName,
  emptyMessage,
  pageSize,
}: PendenciesDashboardTabProps) {
  const attendanceFilter = usePendenciesFilter();

  const attendanceQuery = scheduledLessonsQueryKeys.list({
    ...attendanceFilter.filters,
    pageSize: pageSize ?? 6,
  });

  const {
    results: scheduledLessons,
    isInitialLoading: isLoadingAttendance,
    error: attendanceError,
  } = useListService({
    queryKey: attendanceQuery.queryKey,
    queryFn: attendanceQuery.queryFn,
    enabled: !!user,
    keepPreviousData: true,
    staleTime,
  });

  return (
    <AttendancePendenciesTable
      ordering={attendanceFilter.filters.ordering}
      onToggleOrdering={attendanceFilter.toggleOrdering}
      data={scheduledLessons}
      isLoading={isLoadingAttendance}
      error={attendanceError}
      emptyMessage={emptyMessage}
      classNames={tableClassNames}
      className={tableClassName}
    />
  );
}
